<template>
    <div class="memberStyle">
        <div class="memberContent">
            <div class="memberCover">
                <img src="../../assets/img/newHome/member.png" style="width: 100%;height: 100%;" />
            </div>
            <div class="memberCarousel" >
                <el-row  style="width:100%">
                    <el-col :span="6" v-for="(item, index) in showMembers" :key="index" >
                        <div class="imgLayout" @click="clickProps(item)"  >
                            <img class="imgStyle" :src="item.picUrl" alt="描述图片的文字" />
                            <div  class="imgBottom">
                                <div class="imgTitle" style="margin-left:10px">{{item.title}}</div>
                            </div>
                        </div>
                    </el-col>

                </el-row>
            </div>
           
            
        </div>
        
    </div>
</template>

<script>
import * as dayjs from 'dayjs';
import { prefixedUrlAsset } from '@/utils/constants';
export default {
    props: {
        showMembers: {
            type: Array,
            default: () => {}
        },
    },
    components: {},
    computed: {
    
    },
    data() {
        return {
        
        };
    },
 
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        clickProps(item) {
            window.open(`/#/detail/`+ item.id);          
        }, 
    },
};
</script>

<style lang="less">
    .memberStyle{
        padding: 40px 10%;
        background: #00A287;

        .memberContent{
            display: flex;
            margin-top: 24px;
            height: 300px;
            .memberCarousel{
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                .imgLayout{
                    position: relative;
                    display: inline-block;
                    width: 100%;
                    cursor: pointer;
                    height:150px ;
                    background: #fff;
                    .imgStyle{
                        // display: block;
                        max-width: 100%;
                        height:70px;
                        padding-top: 30px;
                    }
                    .imgBottom{
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        height: 35px; 
                        background-color: rgba(0, 0, 0, 0.6);
                        color: #FFFFFF;
                        width: 100%;
                        font-size: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0;    
                        .imgTitle{
                            display: -webkit-box;
                            word-break: break-all;             
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            overflow: hidden;
                        }
                    }
                }
            }
            .memberCover{
                width: 20%;
                height: 100%;
            }
        }
        
    }

    
    </style>